$(document).ready(function(){
    $(".quantityInputValueValidation").change(function(){
        var letters = /^[A-Za-z]+$/;
     
       if ($(".quantityInputValueValidation").val() < 1 || $(".quantityInputValueValidation").val() > 50) {
      $(".quantityInputValueValidation").css({"border": "1px solid red"});
      $(".quantityInputValueValidation").val(1);
    } 
    else if(inputtxt.value.match(letters))
    {
        $(".quantityInputValueValidation").css({"border": "1px solid red"});
        $(".quantityInputValueValidation").val(1);
        return false;
    }
    else if($("#quantityInputValueValidation").val() == ""){
    {
     $(".quantityInputValueValidation").css({"border": "1px solid red"});
     $(".quantityInputValueValidation").val(1);
     return false;
    }
    }else {
     $(".quantityInputValueValidation").css({"border": "1px solid gray"});
       
    }
    });
   
  });